import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { push } from 'react-router-redux';

// Components
import ExtComp from '../../components/external';
import NewJobWrapper from '../../components/NewJobWrapper/NewJobWrapper';
import CommunicationDetails from './sections/CommunicationDetails';
import RescheduleDetails from './sections/RescheduleDetails';

// Actions
import { createJob, clearNewJob } from '../../reducer/createNewJobActions';

// Services
import { preparingDataForRequest } from './parsingData';

// Style
import s from './NewJobConfirm.style';


const NewJobConfirm = (props) => {
  const {
    common: { campusesList, practitionersList },
    createNewJob: { filters, info, specificDetails },
    dispatch,
    t,
  } = props;

  const onRunJob = () => {
    if (filters && Array.isArray(campusesList)) {

      if (info && info.type === 'communicate') {
        const communicateDate = preparingDataForRequest(campusesList, props.createNewJob);
        console.log('rescheduleDate ', communicateDate);
        dispatch(createJob('/communicate-jobs', communicateDate))
          .then(() => {
            dispatch(clearNewJob());
            dispatch(push('/practitioner/jobs'));
          })
          .catch(() => { });
      }
      if (info && info.type === 'reschedule') {
        const rescheduleDate = preparingDataForRequest(campusesList, props.createNewJob);
        console.log('rescheduleDate ', rescheduleDate);
        dispatch(createJob('/reschedule-jobs', rescheduleDate))
          .then(() => {
            dispatch(clearNewJob());
            dispatch(push('/practitioner/jobs'));
          })
          .catch(() => { });
      }
    }
  };

  const parseCampus = () => {
    if (Array.isArray(campusesList) && filters.campusId) {
      return campusesList.find(({ id }) => String(id) === String(filters.campusId));
    }
    return { name: t('all_available_location') };
  };

  const renderDetailsBlocks = () => {
    switch (info && info.type) {
      case 'communicate': {
        return <CommunicationDetails details={specificDetails} />;
      }
      case 'reschedule': {
        return <RescheduleDetails details={specificDetails} />;
      }
      default: {
        return null;
      }
    }
  };

  const getBackPath = () => {
    switch (info && info.type) {
      case 'communicate': { return '/practitioner/new-job/details'; }
      case 'reschedule': { return '/practitioner/new-job/reschedule-details'; }
      default: { return null; }
    }
  };

  return (
    <NewJobWrapper
      screenTitle={t('nj_confirm_screen_title')}
      percent={100}
      backPath={getBackPath()}
      nextBtnAction={onRunJob}
      nextBtnTitle={info && info.type === 'communicate' ? t('nj_mass_message_send_btn') : t('create_job')}
      nextBtnDisable={!filters || !filters.selectedList.length}
    >
      <s.ConfirmWrapper >
        {/* ──── Info ────────────────────────────────────────────────────────────────────────────── */}
        {info ?
          <div className="confirm-section">
            <div className="row">
              <p className="label">{t('nj_job_type')}</p>
              <p>{t(`nj_mass_${info.type}`)}</p>
            </div>

            <div className="row">
              <p className="label">{t('nj_run_job_time')}</p>
              <p>{t(`nj_start_job_time_option_${info.runTime ? '2' : '1'}`)}</p>
            </div>
          </div>
          : null}


        {/* ──── Appointments ────────────────────────────────────────────────────────────────────── */}
        {filters ? <div className="confirm-section">
          <p className="caption">{t('appointments')}</p>

          <div className="row half">
            <div className="half-row">
              <p className="label">{t('appointments_date')}</p>
              <p>{moment(filters.date).format('DD.MM.YYYY dddd')}</p>
            </div>
            <div className="half-row">
              <p className="label">{t('appointments_selected')}</p>
              <p>{filters.selectedList && filters.selectedList.length}</p>
            </div>
          </div>

          <div className="row doctor">
            <p className="label">{t('doctor')}</p>
            <ExtComp.PractitionerBlock
              practitioner={Array.isArray(practitionersList) && practitionersList.find(pr => pr.id === filters.practitionerId)}
            />
          </div>

          <div className="row">
            <p className="label">{t('location')}</p>
            <ExtComp.CampusBlock campus={parseCampus()} showAddress />
          </div>
        </div>
          : null
        }

        {/* ──── Details ────────────────────────────────────────────────────────────────────── */}
        {renderDetailsBlocks()}

      </s.ConfirmWrapper>
    </NewJobWrapper>
  );
};

const mapStateToProps = store => ({
  createNewJob: store.practitioner.createNewJob,
  common: store.practitioner.common,
});

export default translate()(
  connect(mapStateToProps)(NewJobConfirm)
);